export interface Input {
  messageHeight?: number;
}

import t from "../locales/common.json";

<define/Label|input: { content: Marko.Body; for: string }|>
  <label for=input.for class="text0 mis-1">
    <${input.content}/>
  </label>
</define>

<define/Row|input: { content: Marko.Body }|>
  <div class="flex flex-col gap-5">
    <${input.content}/>
  </div>
</define>

<form
  class="flex flex-col gap0"
  name="contact"
  method="POST"
  netlify-honeypot="content"
  data-netlify="true"
>
  <div class="hidden">
    <input name="content" type="text">
  </div>
  <Row>
    <Label for="name-input">${t.cc.Footer.contact.name}</Label>
    <cc-input id="name-input" name="name" type="text"/>
  </Row>
  <Row>
    <Label for="email-input">${t.cc.Footer.contact.email}</Label>
    <cc-input id="email-input" name="email" type="email"/>
  </Row>
  <Row>
    <Label for="message-input">${t.cc.Footer.contact.message}</Label>
    <cc-textarea id="message-input" rows=input.messageHeight name="message"/>
  </Row>
  <cc-button type="submit" class="align-self-end">
    ${t.cc.Footer.contact.submit}
  </cc-button>
</form>
